<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <category-container>
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/dashboard"
              :class="getRoute() === '/dashboard' ? 'active' : ''"
              :navText="'대시보드'"
              :isCategory="true"
            />
          </li>
        </template>
      </category-container>
      <category-container title="상품 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/category/management"
              :class="getRoute() === '/category/management' ? 'active' : ''"
              :navText="'카테고리 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/certificate-surgery/registration"
              :class="
                getRoute() === '/certificate-surgery/registration'
                  ? 'active'
                  : ''
              "
              :navText="'인증서 시술 관리'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="병원 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/hospital/management"
              :class="getRoute() === '/hospital/management' ? 'active' : ''"
              :navText="'병원 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/hospital/account"
              :class="getRoute() === '/hospital/account' ? 'active' : ''"
              :navText="'병원 계정 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/hospital/crawling"
              :class="getRoute() === '/hospital/crawling' ? 'active' : ''"
              :navText="'수집한 병원정보'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/hospital/ad"
              :class="getRoute() === '/hospital/ad' ? 'active' : ''"
              :navText="'광고 병원 관리'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="제조사 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/manufacturer/management"
              :class="getRoute() === '/manufacturer/management' ? 'active' : ''"
              :navText="'제조사 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/manufacturer/account"
              :class="getRoute() === '/manufacturer/account' ? 'active' : ''"
              :navText="'제조사 계정 관리'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="기공소 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/dental-laboratory/management"
              :class="
                getRoute() === '/dental-laboratory/management' ? 'active' : ''
              "
              :navText="'기공소 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/dental-laboratory/account"
              :class="
                getRoute() === '/dental-laboratory/account' ? 'active' : ''
              "
              :navText="'기공소 계정 관리'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="리셀러 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/reseller/management"
              :class="getRoute() === '/reseller/management' ? 'active' : ''"
              :navText="'리셀러 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/reseller/account"
              :class="getRoute() === '/reseller/account' ? 'active' : ''"
              :navText="'리셀러 계정 관리'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="STUDIO 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/studio/management"
              :class="getRoute() === '/studio/management' ? 'active' : ''"
              :navText="'STUDIO 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/studio/account"
              :class="getRoute() === '/studio/account' ? 'active' : ''"
              :navText="'STUDIO 계정 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/studio/quick-reply-master"
              :class="getRoute().includes('/studio/quick-reply-master') ? 'active' : ''"
              :navText="'자주 사용하는 답변'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="CRM 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/crm/central-scenarios"
              :class="getRoute().startsWith('/crm/central-scenarios') ? 'active' : ''"
              :navText="'시나리오 배포'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/crm/setup-guides"
              :class="getRoute().startsWith('/crm/setup-guides') ? 'active' : ''"
              :navText="'가이드 템플릿'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="챗봇 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/chatbot/counselor"
              :class="getRoute() === '/chatbot/counselor' ? 'active' : ''"
              :navText="'상담톡 관리'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="콜봇 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/callbot/extensions"
              :class="getRoute() === '/callbot/extensions' ? 'active' : ''"
              :navText="'내선 관리'"
            />
          </li>
          <li class="nav-item">
            <!-- 목록(/callbot/settlement)과 병원 상세(/callbot/settlement/:companyId)에서 켠다. 기본 요율은 제외 -->
            <sidenav-item
              url="/callbot/settlement"
              :class="
                getRoute().startsWith('/callbot/settlement') &&
                !getRoute().startsWith('/callbot/settlement/rates')
                  ? 'active'
                  : ''
              "
              :navText="'월 정산'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/callbot/settlement/rates"
              :class="
                getRoute().startsWith('/callbot/settlement/rates') ? 'active' : ''
              "
              :navText="'기본 요율'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="병원검색 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/hospital-search-keyword/manage"
              :class="
                getRoute() === '/hospital-search-keyword/manage' ? 'active' : ''
              "
              :navText="'제외 키워드 관리'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="인증서 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/certificate/customers"
              :class="getRoute() === '/certificate/customers' ? 'active' : ''"
              :navText="'환자 정보 조회'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/certificate/history"
              :class="getRoute() === '/certificate/history' ? 'active' : ''"
              :navText="'인증서 발행 내역 조회'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/certificate-image/management"
              :class="
                getRoute() === '/certificate-image/management' ? 'active' : ''
              "
              :navText="'인증서 이미지 관리'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="고객 도구">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/customer-tools/impersonate"
              :class="getRoute() === '/customer-tools/impersonate' ? 'active' : ''"
              :navText="'대리 로그인'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="정품인증">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/product-auth/qrcode"
              :class="getRoute() === '/product-auth/qrcode' ? 'active' : ''"
              :navText="'QR코드'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="예약 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/banner/management"
              :class="getRoute() === '/banner/management' ? 'active' : ''"
              :navText="'배너 관리'"
            >
            </sidenav-item>
          </li>

          <li class="nav-item">
            <sidenav-item
              url="/reservation/management"
              :class="getRoute() === '/reservation/management' ? 'active' : ''"
              :navText="'예약 관리'"
            >
            </sidenav-item>
          </li>
        </template>
      </category-container>

      <category-container title="추적 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/tracking/insights"
              :class="getRoute() === '/tracking/insights' ? 'active' : ''"
              :navText="'추적 인사이트'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/tracking/info"
              :class="getRoute() === '/tracking/info' ? 'active' : ''"
              :navText="'추적정보조회'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/qr/management"
              :class="getRoute() === '/qr/management' ? 'active' : ''"
              :navText="'QR코드 관리'"
            >
            </sidenav-item>
          </li>
        </template>
      </category-container>
      <category-container title="이벤트 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/events/management"
              :class="getRoute() === '/events/management' ? 'active' : ''"
              :navText="'이벤트 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/events/participation"
              :class="getRoute() === '/events/participation' ? 'active' : ''"
              :navText="'이벤트 참여 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/events/black-patient"
              :class="getRoute() === '/events/black-patient' ? 'active' : ''"
              :navText="'메시지 발송 제외 설정'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/events/ai-prompt"
              :class="getRoute() === '/events/ai-prompt' ? 'active' : ''"
              :navText="'AI 프롬프트 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/events/review"
              :class="getRoute() === '/events/review' ? 'active' : ''"
              :navText="'후기 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/event-dashboard"
              :class="getRoute() === '/event-dashboard' ? 'active' : ''"
              :navText="'이벤트 대시보드'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="프로모션 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/promotions/management"
              :class="getRoute().includes('/promotions') ? 'active' : ''"
              :navText="'제조사 프로모션'"
            />
          </li>
        </template>
      </category-container>

      <category-container title="주문 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/orders/management"
              :class="getRoute() === '/orders/management' ? 'active' : ''"
              :navText="'주문 관리'"
            />
          </li>
        </template>
      </category-container>

      <category-container title="홈페이지 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/homepage/editor"
              :class="getRoute() === '/homepage/editor' ? 'active' : ''"
              :navText="'홈페이지 편집'"
            />
          </li>
        </template>
      </category-container>


      <category-container title="구독 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/system-products"
              :class="getRoute() === '/system-products' ? 'active' : ''"
              :navText="'제품 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/subscription-packages"
              :class="getRoute() === '/subscription-packages' ? 'active' : ''"
              :navText="'구독 상품관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/subscriptions-v2/list"
              :class="getRoute() === '/subscriptions-v2/list' ? 'active' : ''"
              :navText="'구독관리(통합)'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/subscriptions-v2/payment-history"
              :class="
                getRoute() === '/subscriptions-v2/payment-history'
                  ? 'active'
                  : ''
              "
              :navText="'결제내역(통합)'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/salesrecords/centerflow-subscription"
              :class="
                getRoute() === '/salesrecords/centerflow-subscription'
                  ? 'active'
                  : ''
              "
              :navText="'센터플로우 구독 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/salesrecords/subscription"
              :class="
                getRoute() === '/salesrecords/subscription' ? 'active' : ''
              "
              :navText="'플라즈맵 구독 관리'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="계약서 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/contract/labor"
              :class="getRoute() === '/contract/labor' ? 'active' : ''"
              :navText="'근로계약서 조회'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/contract/consent"
              :class="getRoute() === '/contract/consent' ? 'active' : ''"
              :navText="'시술동의서 조회'"
            />
          </li>
        </template>
      </category-container>
      <category-container title="메뉴 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/manufacturer/menu"
              :class="getRoute() === '/manufacturer/menu' ? 'active' : ''"
              :navText="'메뉴 관리'"
            />
          </li>
        </template>
      </category-container>
      <div class="category-container">
        <li class="nav-item">
          <div
            class="category"
            style="
              cursor: pointer;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-right: 20px;
            "
            @click="isOpenLNB = !isOpenLNB"
          >
            등록관리
            <i class="fa-solid fa-plus-circle" v-show="!isOpenLNB" />
            <i class="fa-solid fa-minus-circle" v-show="isOpenLNB" />
          </div>
        </li>
        <div :style="isOpenLNB ? '' : 'overflow:hidden; height:0;'">
          <div class="nav-link">
            <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <slot name="icon"></slot>
            </div>
            <span class="nav-link-text" :class="'ms-1'">덴티움</span>
          </div>
          <li class="nav-item">
            <sidenav-item-two
              url="/item/list?companyName=덴티움"
              :class="
                getRouteFullPath().path === '/item/list' &&
                getRouteFullPath().companyName === '덴티움'
                  ? 'is-active'
                  : ''
              "
              :navText="'- 품목 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item-two
              url="/product-list?companyName=덴티움"
              :class="
                getRouteFullPath().path === '/product-list' &&
                getRouteFullPath().companyName === '덴티움'
                  ? 'is-active'
                  : ''
              "
              :navText="'- 제품 관리'"
            />
          </li>
          <div class="nav-link">
            <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <slot name="icon"></slot>
            </div>
            <span class="nav-link-text" :class="'ms-1'">플라즈맵</span>
          </div>
          <li class="nav-item">
            <sidenav-item-two
              url="/item/list?companyName=주식회사 플라즈맵"
              :class="
                getRouteFullPath().path === '/item/list' &&
                getRouteFullPath().companyName === '주식회사 플라즈맵'
                  ? 'is-active'
                  : ''
              "
              :navText="'- 품목 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item-two
              url="/product-list?companyName=주식회사 플라즈맵"
              :class="
                getRouteFullPath().path === '/product-list' &&
                getRouteFullPath().companyName === '주식회사 플라즈맵'
                  ? 'is-active'
                  : ''
              "
              :navText="'- 제품 관리'"
            />
          </li>
          <div class="nav-link">
            <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <slot name="icon"></slot>
            </div>
            <span class="nav-link-text" :class="'ms-1'">포인트</span>
          </div>
          <li class="nav-item">
            <sidenav-item-two
              url="/item/list?companyName=포인트임플란트"
              :class="
                getRouteFullPath().path === '/item/list' &&
                getRouteFullPath().companyName === '포인트임플란트'
                  ? 'is-active'
                  : ''
              "
              :navText="'- 품목 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item-two
              url="/product-list?companyName=포인트임플란트"
              :class="
                getRouteFullPath().path === '/product-list' &&
                getRouteFullPath().companyName === '포인트임플란트'
                  ? 'is-active'
                  : ''
              "
              :navText="'- 제품 관리'"
            />
          </li>
          <div class="nav-link">
            <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <slot name="icon"></slot>
            </div>
            <span class="nav-link-text" :class="'ms-1'">허먼리프</span>
          </div>
          <li class="nav-item">
            <sidenav-item-two
              url="/item/list?companyName=위드웰임플란트"
              :class="
                getRouteFullPath().path === '/item/list' &&
                getRouteFullPath().companyName === '위드웰임플란트'
                  ? 'is-active'
                  : ''
              "
              :navText="'- 품목 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item-two
              url="/product-list?companyName=위드웰임플란트"
              :class="
                getRouteFullPath().path === '/product-list' &&
                getRouteFullPath().companyName === '위드웰임플란트'
                  ? 'is-active'
                  : ''
              "
              :navText="'- 제품 관리'"
            />
          </li>
          <div class="nav-link">
            <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <slot name="icon"></slot>
            </div>
            <span class="nav-link-text" :class="'ms-1'">하이니스</span>
          </div>
          <li class="nav-item">
            <sidenav-item-two
              url="/item/list?companyName=하이니스"
              :class="
                getRouteFullPath().path === '/item/list' &&
                getRouteFullPath().companyName === '하이니스'
                  ? 'is-active'
                  : ''
              "
              :navText="'- 품목 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item-two
              url="/product-list?companyName=하이니스"
              :class="
                getRouteFullPath().path === '/product-list' &&
                getRouteFullPath().companyName === '하이니스'
                  ? 'is-active'
                  : ''
              "
              :navText="'- 제품 관리'"
            />
          </li>
          <div class="nav-link">
            <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <slot name="icon"></slot>
            </div>
            <span class="nav-link-text" :class="'ms-1'">미제휴 제조사</span>
          </div>
          <li class="nav-item">
            <sidenav-item-two
              url="/item/list"
              :class="
                getRouteFullPath().path === '/item/list' &&
                !getRouteFullPath().companyName
                  ? 'is-active'
                  : ''
              "
              :navText="'- 품목 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item-two
              url="/product-list"
              :class="
                getRouteFullPath().path === '/product-list' &&
                !getRouteFullPath().companyName
                  ? 'is-active'
                  : ''
              "
              :navText="'- 제품 관리'"
            />
          </li>
        </div>
      </div>

      <category-container>
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/monitoring"
              :class="getRoute() === '/monitoring' ? 'active' : ''"
              :navText="'배치 모니터링'"
              :isCategory="true"
            />
          </li>
        </template>
      </category-container>
      <category-container title="카카오 서비스 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/alimtalk/token"
              :class="getRoute() === '/alimtalk/token' ? 'active' : ''"
              :navText="'인증정보 관리'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/alimtalk/results"
              :class="getRoute() === '/alimtalk/results' ? 'active' : ''"
              :navText="'알림톡 전송결과'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/alimtalk/seolbi-tracking"
              :class="getRoute() === '/alimtalk/seolbi-tracking' ? 'active' : ''"
              :navText="'설비 알림톡 추적'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/alimtalk/message-routes"
              :class="getRoute() === '/alimtalk/message-routes' ? 'active' : ''"
              :navText="'발송 경로 관리'"
            >
            </sidenav-item>
          </li>
        </template>
      </category-container>
      <category-container title="상담 레포트">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/consult-report/chat"
              :class="getRoute() === '/consult-report/chat' ? 'active' : ''"
              :navText="'채팅 상담 레포트'"
            >
            </sidenav-item>
          </li>
        </template>
      </category-container>
      <category-container title="마이그레이션">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/migration/afterdoc"
              :class="getRoute() === '/migration/afterdoc' ? 'active' : ''"
              :navText="'afterdoc'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/migration/kakao-biz-1to1"
              :class="getRoute() === '/migration/kakao-biz-1to1' ? 'active' : ''"
              :navText="'카카오 비즈니스 1:1'"
            >
            </sidenav-item>
          </li>
        </template>
      </category-container>
      <category-container title="서티라이프 관리">
        <template #menu>
          <li class="nav-item">
            <sidenav-item
              url="/certilife/account"
              :class="getRoute() === '/certilife/account' ? 'active' : ''"
              :navText="'접속 계정 관리'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/certilife/version/app"
              :class="getRoute() === '/certilife/version/app' ? 'active' : ''"
              :navText="'앱 버전 관리'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/certilife/version/web"
              :class="getRoute() === '/certilife/version/web' ? 'active' : ''"
              :navText="'웹 버전 관리'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/certilife/notice/list"
              :class="getRoute().includes('/certilife/notice') ? 'active' : ''"
              :navText="'공지사항 관리'"
            >
            </sidenav-item>
            <sidenav-item
              url="/certilife/whitelist"
              :class="
                getRoute().includes('/certilife/whitelist') ? 'active' : ''
              "
              :navText="'보안 설정'"
            >
            </sidenav-item>
            <!-- 막혔을 요청(T-CONTRACT-1031 §3): 검사 모드와 같은 ops.security.manage 가 있을 때만 -->
            <sidenav-item
              v-if="canObservations"
              url="/certilife/perm-observations"
              :class="getRoute().includes('/certilife/perm-observations') ? 'active' : ''"
              :navText="'막혔을 요청'"
            >
            </sidenav-item>
            <!-- 이용 내역(W6 A2): ops.audit.view 가 있을 때만(introspect perms 가 없으면 보임 — 서버가 판정) -->
            <sidenav-item
              v-if="canAuditMenu"
              url="/certilife/audit-logs"
              :class="getRoute().includes('/certilife/audit-logs') ? 'active' : ''"
              :navText="'이용 내역'"
            >
            </sidenav-item>
            <sidenav-item
              v-if="canAuditView"
              url="/certilife/audit-checks"
              :class="getRoute().includes('/certilife/audit-checks') ? 'active' : ''"
              :navText="'이용 내역 점검'"
            >
            </sidenav-item>
            <sidenav-item
              url="/certilife/geo-allow-ips"
              :class="
                getRoute().includes('/certilife/geo-allow-ips') ? 'active' : ''
              "
              :navText="'국외 허용 IP'"
            >
              <a-badge
                :count="$store.state.geoAllowPendingCount"
                :title="`승인 대기 ${$store.state.geoAllowPendingCount}건`"
                class="ms-2"
              />
            </sidenav-item>
            <sidenav-item
              url="/certilife/send-whitelist"
              :class="
                getRoute().includes('/certilife/send-whitelist') ? 'active' : ''
              "
              :navText="'발송 화이트리스트'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/certilife/environments"
              :class="
                getRoute().includes('/certilife/environments') ? 'active' : ''
              "
              :navText="'API 환경변수 관리'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/db-access"
              :class="getRoute() === '/db-access' ? 'active' : ''"
              :navText="'임시 DB 접근키'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/certilife/coupon-providers"
              :class="
                getRoute().includes('/certilife/coupon-providers')
                  ? 'active'
                  : ''
              "
              :navText="'쿠폰 공급사 관리'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/certilife/manual-coupons"
              :class="getRoute().includes('/certilife/manual-coupons') ? 'active' : ''"
              :navText="'수동 쿠폰 배포'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/certilife/connector"
              :class="getRoute() === '/certilife/connector' ? 'active' : ''"
              :navText="'커넥터 관리'"
            />
          </li>
          <li class="nav-item">
            <sidenav-item
              url="/storage"
              :class="getRoute() === '/storage' ? 'active' : ''"
              :navText="'자료실'"
            >
            </sidenav-item>
          </li>
          <li class="nav-item ps-4">
            <sidenav-item
              url="/storage/upload"
              :class="getRoute() === '/storage/upload' ? 'active' : ''"
              :navText="'- 파일 업로드'"
            >
            </sidenav-item>
          </li>
        </template>
      </category-container>
    </ul>
  </div>
</template>

<script>
import SidenavItem from "@/views/components/Sidenav/SidenavItem.vue";
import SidenavItemTwo from "@/views/components/Sidenav/SidenavItemTwo.vue";
import CategoryContainer from "@/views/components/Sidenav/CategoryContainer.vue";
import GeoAllowIpApi from "@/views/CertiManage/GeoAllowIp/api";
import { canMenu, permsOf } from "@/utils/perm";
import { canSeeObservations } from "@/utils/permObservations";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "",
      controls: "",
      isActive: "active",
      isOpenLNB: false,
    };
  },
  components: {
    SidenavItem,
    SidenavItemTwo,
    CategoryContainer,
  },
  computed: {
    // 새 권한 메뉴 — 라우터 가드(meta.menu)와 같은 canMenu·MENU_PERMS(utils/perm.js)
    canAuditView() {
      return canMenu(permsOf(this.$store.state.introspect), "auditChecks");
    },
    canAuditMenu() {
      return canMenu(permsOf(this.$store.state.introspect), "auditLogs");
    },
    canObservations() {
      return canSeeObservations(this.$store.state.introspect);
    },
  },
  watch: {
    // 국외 허용 IP 승인 대기 건수(D-139): 화면을 옮길 때마다 새로 센다. 실패하면 배지만 안 바뀐다
    "$route.path": {
      immediate: true,
      handler() {
        if (!localStorage.getItem("accessTokenCerti")) return;
        GeoAllowIpApi.pendingCount()
          .then((count) => this.$store.commit("setGeoAllowPendingCount", count))
          .catch(() => {});
      },
    },
  },
  methods: {
    getRoute() {
      return this.$route.path;
    },
    getRouteFullPath() {
      return {
        path: this.$route.path,
        companyName: this.$route.query.companyName,
      };
    },
  },
};
</script>
